<template>
    <div>        
        <v-dialog v-model="showPersonSearchDialog">
            <PeopleList :useForSelection="true" :onRowSelected="onPersonSelected"/>
        </v-dialog>
          <div class="text-left">
            <v-row v-if="!hideSearch" class="ma-0 pa-0">
                <v-col cols="8" class="ma-0 pa-0">
                    <v-text-field 
                        v-model="selectedJudgeId"
                        :label="label ? label : 'Judge ID'" 
                        />
                </v-col>
                <v-col class="ma-0 pa-0">
                    <div class="text-center">
                        <v-btn class="mt-5 ml-1" icon small v-on:click="loadPersonInfo()" color="primary">
                        <v-icon> mdi-refresh </v-icon>
                        </v-btn>
                        <v-btn class="mt-5 ml-1" icon small v-on:click="showPersonSearchDialog = true" :disabled="!isEditMode || hideSearch" color="primary">
                        <v-icon> mdi-magnify </v-icon>                        
                        </v-btn> 
                    </div>
                </v-col>
            </v-row>
            <div v-if="personInfo && personInfo.personId">
              <v-row class="ma-0 pa-0">
                    <v-col cols="12" class="ma-0 pa-0">
                      <span class="text--secondary caption">
                        <a :href="`/admin/people/${personInfo.personId}`" target="_blank">
                            {{ personInfo.firstName }} {{ personInfo.lastName }}                            
                        </a>
                        <span v-if="personInfo.isMember">&nbsp;(Member ID#: {{personInfo.memberInfo.memberId}})</span>  
                      </span>
                    </v-col>
              </v-row>
            </div>
            <div v-else>
              <span v-if="!!selectedJudgeId">Judge not found</span>
            </div>             
        </div>
    </div>      
</template>
<script lang="ts">
import Vue from 'vue';
import PeopleList from "./Searches/PeopleList.vue";
import AdminCoownersList from "./AdminCoownersList.vue";

import peopleService from "@/services/admin/peopleService";

export default Vue.extend({
  name: 'AdminPersonSearchDialog',
  props: {
    judgeId: { type: String },
    initialJudgeId: { type: String },
    isEditMode: { type: Boolean },
    hideSearch: { type: Boolean },
    hideOwners: { type: Boolean },
    label: { type: String },
  },
  components: {
    AdminCoownersList,
    PeopleList
  },
  data: function() {
      return {
        showPersonSearchDialog: false,
        personInfo: {} as any,
        selectedJudgeId: this.$props.judgeId
      };
  },
  created: function () {
    if(!!this.selectedJudgeId){
      this.loadPersonInfo();
    }
  },
  methods: { 
    onPersonSelected: function({judgeId}: any){
        this.showPersonSearchDialog = false;
        if(!!judgeId){
            this.selectedJudgeId = judgeId;
            this.loadPersonInfo();
        } else {
            this.selectedJudgeId = null;
            this.personInfo = {};
        }
    },
    loadPersonInfo: function() {
        this.$store.dispatch("changeLoaderStatus",true);
        peopleService.getPersonByJudgeId(this.selectedJudgeId).then((res: any) => {
          if(res){
            this.personInfo = res;
          } else {
            this.personInfo = {};
          }
        }).catch(() => {
          this.personInfo = {};
        })
        .finally(() => {
          this.$store.dispatch("changeLoaderStatus",false);
        });
    },
  },
  watch: {
    judgeId: function(newVal, oldVal){
      if(newVal != oldVal){
        this.selectedJudgeId = newVal;
      }
    },  
    initialJudgeId: function(newVal, oldVal){
      if(newVal != oldVal) {
        this.loadPersonInfo(); 
      }   
    },
    selectedJudgeId: function(newVal, oldVal){      
      this.$emit('update:judgeId', newVal);
    }
  }
});
</script>
